const hexColors  = [
'#0A84FF',
'#5EE1FF',
'#34C759',
'#44D7B6',
'#FF5E67',
'#FF9500',
'#7E34C7',
'#B620E0',
]

const defaultColor = '0A84FF';

export { hexColors, defaultColor };